import React from "react";
import SessionScheduleManager from '../SessionScheduleManager/SessionScheduleManager'

export default ({
  sessions,
  eventId
}) => {
  return (
    <div style={{
      paddingTop: '20px'
    }}>
      <SessionScheduleManager
        sessions={sessions}
        eventId={eventId}
        isReadOnly={true}
        // defaultView='agenda'
      />
    </div>
  )
}